import { Injectable } from '@angular/core';
import { LocalizedText } from '@ats/cm/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class CmPageHeaderService {
	readonly heading$: Observable<LocalizedText | string | null>;

	private readonly heading = new BehaviorSubject<LocalizedText | string | null>(null);

	constructor() {
		this.heading$ = this.heading.asObservable();
	}

	setHeader(headingConfig: LocalizedText | string): void {
		this.heading.next(headingConfig);
	}
}
